// Azure AD configuration for Selkirk Copper Drilling Dashboard
// Environment detection
const isDevelopment = window.location.hostname === 'dev.selkirkcopper.com';
const isLocalDev = window.location.hostname === 'localhost';

export const msalConfig = {
  auth: {
    clientId: "b091bcac-4be0-4a8a-a85c-4fbdd936a19d",
    authority: "https://login.microsoftonline.com/93d1878a-5a85-4b39-9f80-93d1182cc0b7",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false // Important for SPAs
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    allowNativeBroker: false // Ensure we're using browser-based auth
  }
};

// API scopes for token requests
export const apiScopes = {
  // Standard Microsoft Graph scopes
  userProfile: {
    scopes: ['User.Read'] // Basic user profile access
  },
  
  // Scopes for QGIS API access (custom scope with group claims)
  qgisApi: {
    scopes: [`api://b091bcac-4be0-4a8a-a85c-4fbdd936a19d/access_as_user`] // Custom scope for QGIS access
  },
  // Separate scope for group membership
  groupAccess: {
    scopes: ['User.Read', 'GroupMember.Read.All', 'Group.Read.All'] // For group membership detection
  },
  // Resolve other users' display names (requires admin consent on app registration)
  directoryRead: {
    scopes: ['User.ReadBasic.All'],
  },
};

// APIM endpoints - CLEAN ARCHITECTURE CONFIGURATION
export const apiConfig = {
  production: {
    // Frontend stays on custom domain
    frontendUrl: "https://app.selkirkcopper.com",
    // API calls use APIM default domain (direct, no redirects)
    apiBaseUrl: "https://minto-qgis-apim.azure-api.net",
    // Legacy compatibility
    baseUrl: "https://minto-qgis-apim.azure-api.net", // For existing services
    apimUrl: "https://minto-qgis-apim.azure-api.net",
    containerUrl: "https://minto-qgis-server--u13h8ay.ambitiousrock-2ba87bb9.canadacentral.azurecontainerapps.io"
  },
  development: {
    frontendUrl: "https://dev.selkirkcopper.com",
    apiBaseUrl: "https://minto-qgis-apim.azure-api.net", // Same APIM for dev
    baseUrl: "https://minto-qgis-apim.azure-api.net",
    apimUrl: "https://minto-qgis-apim.azure-api.net",
    containerUrl: "https://minto-qgis-server--u13h8ay.ambitiousrock-2ba87bb9.canadacentral.azurecontainerapps.io"
  }
};

// Get current environment configuration
export const getCurrentConfig = () => {
  if (isDevelopment) return apiConfig.development;
  if (isLocalDev) return apiConfig.development; // Use dev config for local development
  return apiConfig.production;
};

// CURRENT WORKING ENDPOINTS (for reference)
export const workingEndpoints = {
  // These endpoints require Bearer tokens with group membership
  wmsCapabilities: "https://app.selkirkcopper.com/qgis/qgis_mapserv.fcgi?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
  wfsCapabilities: "https://app.selkirkcopper.com/qgis/qgis_mapserv.fcgi?SERVICE=WFS&REQUEST=GetCapabilities",
  health: "https://app.selkirkcopper.com/health",
  
  // Alternative working URLs (APIM default domain)
  apimWms: "https://minto-qgis-apim.azure-api.net/qgis/qgis_mapserv.fcgi?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
  apimHealth: "https://minto-qgis-apim.azure-api.net/health"
};

